function PageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <main className="bg-[#f5f5f5] w-full min-h-[900px] pt-8 pb-8">
        <div className="bg-white w-[85%] min-h-[800px] pt-12 m-auto flex flex-col justify-between gap-16">{children}</div>
    </main>
  );
}

export default PageWrapper;
